import {AfterContentInit, Component, ContentChildren, Input, QueryList} from '@angular/core';
import {MatListItem} from '@angular/material/list';

@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.css'],
    standalone: false
})
export class ListComponent implements AfterContentInit {
  @Input() totalCount: number = 0;
  @Input() maxCount: number = 0;
  @Input() emptyMessage: string;

  showEmptyMessage: boolean = false;

  @ContentChildren(MatListItem) items: QueryList<MatListItem>;

  constructor() {
  }

  ngAfterContentInit() {
    this.items.changes.subscribe((e) => {
      this.showEmptyMessage = this.items.length == 0 && this.emptyMessage !== undefined;
      console.log(e);
    });

    this.showEmptyMessage = this.items.length == 0 && this.emptyMessage !== undefined;
    console.log(this.items);
  }
}
